import * as React from "react";

import primaryColour from "../../constants";

function SvgTrailerdetached(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.9506 13.7917C21.9833 13.4628 22 13.1292 22 12.7917C22 12.4542 21.9833 12.1207 21.9506 11.7917H18.6338C18.2363 11.7917 17.8902 11.5437 17.6422 11.2331C17.1841 10.6594 16.4787 10.2917 15.6875 10.2917C14.3068 10.2917 13.1875 11.411 13.1875 12.7917C13.1875 14.1725 14.3068 15.2917 15.6875 15.2917C16.4787 15.2917 17.1841 14.9241 17.6422 14.3504C17.8902 14.0398 18.2363 13.7917 18.6338 13.7917H21.9506Z"
        fill={fill}
      />
      <path
        d="M2.11175 11.2917C2.03815 11.781 2 12.2819 2 12.7917C2 13.3016 2.03815 13.8025 2.11175 14.2917H3.881C4.34472 14.2917 4.73993 14.614 4.90097 15.0489C5.81833 17.5261 8.20215 19.2917 10.9984 19.2917C12.0261 19.2917 13.0008 19.0525 13.8673 18.6257C14.3627 18.3817 14.5665 17.7822 14.3225 17.2868C14.0785 16.7913 13.479 16.5875 12.9836 16.8316C12.3859 17.1259 11.7129 17.2917 10.9984 17.2917C8.51309 17.2917 6.49837 15.277 6.49837 12.7917C6.49837 10.3065 8.51309 8.29175 10.9984 8.29175C11.6193 8.29175 12.2084 8.41694 12.7438 8.6425C13.2528 8.85692 13.8392 8.61815 14.0536 8.10919C14.268 7.60023 14.0293 7.01381 13.5203 6.79939C12.7435 6.47214 11.8907 6.29175 10.9984 6.29175C8.20215 6.29175 5.81833 8.05739 4.90097 10.5346C4.73993 10.9695 4.34472 11.2917 3.881 11.2917H2.11175Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgTrailerdetached;
